<template>
  <router-view #="{ Component }">
    <a-config-provider
      :theme="{
        token: {
          colorPrimary: store.themeColor,
        },
      }"
    >
      <component :is="Component" />
    </a-config-provider>
  </router-view>
</template>
<script setup>
import { userStore } from '@/store/user';
const store = userStore();
</script>
